



















import TheMoviesColumn from '@/components/TheMoviesColumn'

export default
    # The number of rows and columns to show
    props: ['rows', 'columns']

    components: { TheMoviesColumn }

    computed:
        years: ->
            year_max = @$store.state.display.year
            return [year_max..year_max-@columns+1]

        group_by_year: ->
            return @$store.state.display.group_by_year

        topindex: ->
            return @$store.state.display.topindex

        cache: ->
            start = window.performance.now()

            # make sure cache is refreshed when the movie_changes state is changed
            trigger = @$store.state.data.movies_changes

            # country, genre and language filters grouped
            filters_country = {'neutral': [], 'required': [], 'forbidden': []}
            for key, value of @$store.state.filter.countries
                str = 'forbidden' if value.filter == 0
                str = 'neutral' if value.filter == 1
                str = 'required' if value.filter == 2
                filters_country[str].push(value.id)

            filters_genre = {'neutral': [], 'required': [], 'forbidden': []}
            for key, value of @$store.state.filter.genres
                str = 'forbidden' if value.filter == 0
                str = 'neutral' if value.filter == 1
                str = 'required' if value.filter == 2
                filters_genre[str].push(value.id)

            filters_language = {'neutral': [], 'required': [], 'forbidden': []}
            for key, value of @$store.state.filter.languages
                str = 'forbidden' if value.filter == 0
                str = 'neutral' if value.filter == 1
                str = 'required' if value.filter == 2
                filters_language[str].push(value.id)

            # the ranges, a bit more accessible
            imdb_score_min = @$store.state.filter.range.imdb_score.min * 10
            imdb_score_max = @$store.state.filter.range.imdb_score.max * 10
            imdb_votes_min = @$store.state.filter.range.imdb_votes.min
            imdb_votes_max = @$store.state.filter.range.imdb_votes.max
            mc_min = @$store.state.filter.range.metacritic_score.min * 10
            mc_max = @$store.state.filter.range.metacritic_score.max * 10
            year_min = @$store.state.filter.range.year.min
            year_max = @$store.state.filter.range.year.max
            runtime_min = @$store.state.filter.range.runtime.min
            runtime_max = @$store.state.filter.range.runtime.max
            imdb_check_min = @$store.state.filter.range.imdb_last_check_time.min
            imdb_check_max = @$store.state.filter.range.imdb_last_check_time.max

            # prepare the container (we store indices only)
            all = []
            yearmap = {}
            for year in @years
                yearmap[year] = []

            # counters for absolute and relative year rank (i.e. index) numbers
            global_counter = 0
            year_counter = {}
            year_counter[year] = 0 for year in [1900..2019]

            # the keys are sorted by how we want the result to be sorted
            keys = @$store.state.sort.keys[@$store.state.sort.choice]

            # loop over all movies and store the indices that match our filters
            keys.forEach (key) =>
                movie = @$store.state.data.movies.get(key)
                global_counter++
                year_counter[movie.year]++

                # exclude years for columns that are not on screen
                if @group_by_year
                    if movie.year < @$store.state.display.year - @columns + 1
                        return
                    if movie.year > @$store.state.display.year
                        return
                # exclude years for years outside of the range
                else
                    if movie.year < year_min
                        return
                    if movie.year > year_max
                        return

                # exclude all movies or series
                if @$store.state.display.movies_or_series == 2 and movie.type == 'Movie'
                    return
                if @$store.state.display.movies_or_series == 0 and movie.type == 'Serie'
                    return

                # exclude from searching
                if @$store.state.search.title
                    if movie.title.toLowerCase().indexOf(@$store.state.search.title.toLowerCase()) < 0 # XXX maybe cache the lower case?
                        return

                # if @$store.state.data.persons_filter.length > 0
                #     any = false
                #     for person_id in @$store.state.data.persons_filter
                #         if person_id in movie.persons
                #             any = true
                #             break
                #     return if not any

                # exclude based on other range filters
                if movie.runtime < runtime_min
                    return
                if movie.runtime > runtime_max
                    return
                if movie.imdb_score < imdb_score_min
                    return
                if movie.imdb_score > imdb_score_max
                    return
                if movie.metacritic_score
                    if movie.metacritic_score < mc_min
                        return
                    if movie.metacritic_score > mc_max
                        return

                # exclude based on general filters
                if @$store.state.filter.in_collection == 0 and movie.collection_time
                    return
                if @$store.state.filter.in_collection == 2 and not movie.collection_time
                    return
                if @$store.state.filter.seen == 0 and movie.own_score
                    return
                if @$store.state.filter.seen == 2 and not movie.own_score
                    return
                if @$store.state.filter.reviewed == 0 and movie.written_review
                    return
                if @$store.state.filter.reviewed == 2 and not movie.written_review
                    return
                if @$store.state.filter.released == 0 and movie.br1080p
                    return
                if @$store.state.filter.released == 2 and not movie.br1080p
                    return
                if @$store.state.filter.hidden == 0 and movie.hidden
                    return
                if @$store.state.filter.hidden == 2 and not movie.hidden
                    return

                # apply language, country and genre filters
                if filters_country.forbidden.length > 0
                    for country in movie.countries
                        if country in filters_country.forbidden
                            return
                for country in filters_country.required
                    if country not in movie.countries
                        return
                if filters_genre.forbidden.length > 0
                    for genre in movie.genres
                        if genre in filters_genre.forbidden
                            return
                for genre in filters_genre.required
                    if genre not in movie.genres
                        return
                if filters_language.forbidden.length > 0
                    for language in movie.languages
                        if language in filters_language.forbidden
                            return
                for language in filters_language.required
                    if language not in movie.languages
                        return


                movie.global_index = global_counter
                movie.year_index = year_counter[movie.year]

                all.push(key)
                if @group_by_year
                    yearmap[movie.year].push(key)

            console.log "Computed cache: ", window.performance.now() - start, " for #{global_counter} items"

            if @group_by_year
                return
                    'indices_by_year': yearmap
                    'unfiltered_count_by_year': year_counter
            else
                return
                    'indices_all': all
                    'unfiltered_count_all': global_counter

        column_indices_by_year: ->
            # Return just the indices to show in the columns. This is a subset of the cache.
            start = window.performance.now()
            cache = @cache['indices_by_year']
            indices = []
            i = @topindex - 1 # topindex counts from 1 but arrays count from 0
            for year in @years
                indices.push cache[year][i..i+@rows]

            # We should load more movies if the column is blank (no movies)
            for year, index in @years
                if indices[index].length == 0
                    @$store.dispatch("data/loadMoreMovies", year)

            duration = window.performance.now() - start
            if duration > 10
                console.log "Computed years took long (ms) : ", duration
            return indices

        columns_indices_by_column: ->
            start = window.performance.now()
            cache = @cache['indices_all']
            indices = []
            i = @topindex - 1
            for year in @years
                indices.push cache[i..i+@rows]
                i += @rows + 1
            console.log "Computed columns: ", window.performance.now() - start
            return indices

